/**************************************************
 * Nombre:       Home_Banners_Peq
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tarjeta_Banner_Verde from "../../Tarjetas/Tarjeta_Banner_Verde";
import Tarjeta_Banner_Naranja from "../../Tarjetas/Tarjeta_Banner_Naranja";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../../App";

const Home_Banners_Peq = () => {
    const {sCell} = useResponsive()
    const cData = useContext(contexApp)
    const [banners, setBanners] = useState([])


    const Banner = ({item}) => {

        if (item.tipo === 'Azul') {
            return (
                <Tarjeta_Banner_Verde item={item}/>
            )
        }

        if (item.tipo === 'Naranja') {
            return (
                <Tarjeta_Banner_Naranja item={item}/>
            )
        }


    }

    useEffect(() => {

        if (cData.banners) {
            setBanners(cData.banners);
        }

    }, [cData])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Splide
                        aria-label="My Favorite Images" style={{width: '100%'}}
                        options={{
                            autoplay: true,
                            speed: 1500,
                            rewind: true,
                            perPage: sCell ? 1 : 2,
                            arrows: false,
                            pagination: true,
                            width: '100%',
                            drag: true,
                            interval: 8000,
                            noDrag: false,
                            type: 'loop',
                            gap: 50
                        }}
                    >

                        {banners.map((item, index) => {
                            return (
                                <SplideSlide key={`qe${index}`}>
                                    <Banner item={item} />
                                </SplideSlide>
                            )
                        })}


                    </Splide>

                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Banners_Peq  